import { subscribe } from '@/utils'

import { Response } from '.'

const submit = async (): Promise<Response> => {
	try {
		const body = {}
		const res = await subscribe.post<Response>(
			'sales/stop-recurring-setup',
			body
		)
		return res.data
	} catch (e) {
		throw e
	}
}

export const service = {
	submit
}
